import script from "./User-Profile.vue?vue&type=script&setup=true&lang=js"
export * from "./User-Profile.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__